import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DIAM_TEAM_ID,
  diamQueryKeys,
  getTeamMembership,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';

export function useTeamMembership(identityId: string | undefined) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  return useQuery({
    queryKey: diamQueryKeys.teamMembership(DIAM_TEAM_ID, identityId ?? ''),
    queryFn: async () => {
      if (!identityId) {
        throw new Error('An identity id is required');
      }

      const idToken = await getIdToken();
      return getTeamMembership(apiUrl, idToken, identityId);
    },
    enabled: isSignedIn && Boolean(identityId),
    retry: false,
    refetchOnWindowFocus: false,
  });
}
